import { render, staticRenderFns } from "./autl.vue?vue&type=template&id=18b56704&scoped=true&"
import script from "./autl.vue?vue&type=script&lang=js&"
export * from "./autl.vue?vue&type=script&lang=js&"
import style0 from "./autl.vue?vue&type=style&index=0&id=18b56704&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b56704",
  null
  
)

export default component.exports